import { render, staticRenderFns } from "./add-article.vue?vue&type=template&id=3cd331c6&scoped=true"
import script from "./add-article.vue?vue&type=script&lang=js"
export * from "./add-article.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd331c6",
  null
  
)

export default component.exports